import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { BrainIcon, CogIcon, CodeIcon, TrendingUpIcon, BarChart3Icon, LinkIcon } from 'lucide-react';
export function ServicesSection() {
  const services = [{
    icon: BrainIcon,
    title: 'Generative AI Solutions',
    description: 'Custom LLM implementations, content generation, and conversational AI for your business.'
  }, {
    icon: CogIcon,
    title: 'Intelligent Automation',
    description: 'Streamline operations with AI-powered workflow automation and process optimization.'
  }, {
    icon: CodeIcon,
    title: 'Custom AI Development',
    description: 'Bespoke AI models and applications built specifically for your unique business challenges.'
  }, {
    icon: TrendingUpIcon,
    title: 'AI Transformation Consulting',
    description: 'Strategic roadmaps to seamlessly integrate AI across your enterprise operations.'
  }, {
    icon: BarChart3Icon,
    title: 'Data Analytics & Insights',
    description: 'Turn your raw data into actionable intelligence with advanced predictive analytics.'
  }, {
    icon: LinkIcon,
    title: 'AI Integration Services',
    description: 'Seamlessly connect powerful AI capabilities with your existing technology stack.'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  return <section id="services" className="py-24 bg-[#1e1b1c] relative" data-id="element-165">
      <div className="absolute inset-0 grid-pattern opacity-20" data-id="element-166"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-167">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-168">
          <div className="inline-flex items-center justify-center gap-2 mb-4" data-id="element-169">
            <div className="w-8 h-1 bg-brand-primary rounded-full" data-id="element-170"></div>
            <h2 className="text-brand-primary font-semibold uppercase tracking-wider text-sm" data-id="element-171">
              Our AI Solutions
            </h2>
            <div className="w-8 h-1 bg-brand-primary rounded-full" data-id="element-172"></div>
          </div>
          <h3 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-173">
            End-to-end AI capabilities tailored for African enterprises
          </h3>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8" data-id="element-174">
          {services.map((service, index) => {
          const Icon = service.icon;
          return <motion.div key={index} variants={itemVariants} whileHover={{
            y: -10
          }} className="glass-card p-8 rounded-2xl group hover:border-brand-primary/50 transition-all duration-300 relative overflow-hidden" data-id="element-175">
                {/* Hover Glow Background */}
                <div className="absolute inset-0 bg-brand-primary/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-176"></div>

                <div className="relative z-10" data-id="element-177">
                  <div className="w-14 h-14 rounded-full bg-brand-primary/10 flex items-center justify-center mb-6 group-hover:scale-110 group-hover:bg-brand-primary/20 transition-all duration-300" data-id="element-178">
                    <Icon className="w-7 h-7 text-brand-primary" data-id="element-179" />
                  </div>
                  <h4 className="text-xl font-bold text-white mb-3 group-hover:text-brand-light transition-colors" data-id="element-180">
                    {service.title}
                  </h4>
                  <p className="text-gray-400 leading-relaxed" data-id="element-181">
                    {service.description}
                  </p>
                </div>
              </motion.div>;
        })}
        </motion.div>
      </div>
    </section>;
}